import CareerPurchaseActionBanner from './CareerPurchaseActionBanner'
export default CareerPurchaseActionBanner
